import { DIOPTRA_LOGIN_METHOD } from "../constants";
import { clearApiKey } from "./addin-auth";
import { getEnv } from "./envManager";
import { safeFetch } from "./safe-fetch";
import { reloadTaskpane } from "./taskpane-reload";
import { toastError } from "./toast";

async function revokeAddinKeysOnServer(webappBaseUrl: string, authHeader: string): Promise<void> {
  try {
    await safeFetch(`${webappBaseUrl}/api/auth/addin-code`, {
      method: "DELETE",
      headers: { Authorization: authHeader },
    });
  } catch (err) {
    const status = (err as { status?: number }).status;
    if (status === 401 || status === 403) return;
    console.error("Failed to revoke add-in key:", err);
    toastError("Logged out, but couldn't revoke the add-in key on the server.");
  }
}

export async function logOutOfAddin(authHeader: string | null): Promise<void> {
  const webappBaseUrl = getEnv("WEBAPP_API_BASE_URL");
  if (webappBaseUrl && authHeader) await revokeAddinKeysOnServer(webappBaseUrl, authHeader);
  localStorage.removeItem(DIOPTRA_LOGIN_METHOD);
  clearApiKey();
  reloadTaskpane();
}
